import { Divider as MuiDivider, styled, Theme } from "@mui/material";
import { DividerColor } from "./types";

const pickColor = (theme?: Theme): Record<DividerColor, any> => ({
    primary: (theme as any)?.palette?.primary?.main,
    secondary: (theme as any)?.palette?.secondary?.light,
    tertiary: (theme as any)?.palette?.tertiary?.main,
    quaternary: (theme as any)?.palette?.tertiary?.light,
    neutral: (theme as any)?.palette?.neutral?.main,
    accentInfo: (theme as any)?.palette?.accentInfo?.main,
    accentSuccess: (theme as any)?.palette?.accentSuccess?.main,
    accentWarning: (theme as any)?.palette?.accentWarning?.main,
    accentError: (theme as any)?.palette?.accentError?.main,
});

const StyledDivider = styled(MuiDivider, {
    shouldForwardProp: (prop) => prop !== "customColor",
})<{ customColor?: DividerColor }>(({ theme, customColor = "neutral" }) => {
    const color = pickColor(theme)[customColor] ?? (theme as any).palette?.divider;
    return {
        borderColor: color,
        backgroundColor: color,
    };
});

export { StyledDivider };

